<template>
  <VaCard>
    <VaCardContent>
      <div class="mx-auto">
        <RouterView></RouterView>
      </div>
    </VaCardContent>
  </VaCard>
</template>
